export default class Deferred<T> {
  private readonly _promise: Promise<T>;
  private _resolve: (value?: T | PromiseLike<T>) => void;
  private _reject: (reason?: any) => void;
  private _isComplete: boolean = false;

  constructor() {
    this._promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  public get isComplete() {
    return this._isComplete;
  }

  public get promise(): Promise<T> {
    return this._promise;
  }

  public resolve = (value?: T | PromiseLike<T>): Deferred<T> => {
    this._isComplete = true;
    this._resolve(value);
    return this;
  };

  public reject = (reason?: any): Deferred<T> => {
    this._isComplete = true;
    this._reject(reason);
    return this;
  };
}
